import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useSelector } from "react-redux";
import { surveySelector } from "../../redux/surveySlice";
import StepControl from "../survey-form/StepControl";
import Stepper from "../survey-form/Stepper";
import SurveyForm from "../survey-form/SurveyForm";

const InspectionModal = (props) => {
  const ref = useRef();
  const [active, setActive] = useState("addInfo");
  const [isSketchExpanded, setIsSketchExpanded] = useState(false);
  const { inspection } = useSelector(surveySelector);

  const handleStepChange = (step) => {
    setActive(step);
    if (step !== "addInfo") {
      setIsSketchExpanded(false);
    }
  };

  const handleClose = () => {
    props.onHide();
    setActive("addInfo");
    setIsSketchExpanded(false);
  };

  return (
    <>
      <Modal
        {...props}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        className={`modalDrawer ${
          isSketchExpanded ? "modalDrawer--sketch-expanded" : ""
        }`}
      >
        <Modal.Header closeButton>
          <div className="w-100 d-flex align-items-center">
            <Modal.Title id="contained-modal-title-vcenter">
              Building #
              {props.index !== -1
                ? props.index + 1
                : inspection
                ? inspection.length + 1
                : "1"}
            </Modal.Title>
            <button className="btn text-white" onClick={handleClose}>
              Cancel
            </button>
          </div>
          <Stepper active={active} setActive={handleStepChange} />
        </Modal.Header>
        <SurveyForm
          ref={ref}
          active={active}
          isSketchExpanded={isSketchExpanded}
          onToggleSketchSize={() => setIsSketchExpanded((value) => !value)}
        />
        <StepControl
          active={active}
          index={props.index}
          setActive={handleStepChange}
          onClose={handleClose}
          ref={ref}
        />
      </Modal>
    </>
  );
};

export default InspectionModal;
